import React, { useCallback } from 'react';
import MenuItem from '@mui/material/MenuItem';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { useDispatch } from 'react-redux';
import useLanguage from 'hooks/useLanguage';
import { localeUpdated } from 'state/actions/i18nActions';
import { LANGUAGE_OPTIONS } from './constants';
import { Container, StyledSelect } from './style';

import type { SelectChangeEvent } from '@mui/material';

interface ILanguageSelectorProps {
  availableLanguages?: string[];
  className?: string;
  currentLanguage?: string;
  onChange: (language: string) => void;
}

const LanguageSelector = ({
  availableLanguages,
  currentLanguage,
  onChange,
}: ILanguageSelectorProps) => {
  const dispatch = useDispatch();
  const Language = useLanguage();

  const handleChange = useCallback(
    (e: SelectChangeEvent<unknown>) => {
      const locale = e.target.value as string;

      dispatch(localeUpdated(locale));
      onChange(locale);
    },
    [dispatch, onChange],
  );

  if (!availableLanguages?.length) {
    return null;
  }
  return (
    <Container className="text-sm">
      <LanguageIcon fontSize="inherit" color="primary" />
      <StyledSelect
        IconComponent={KeyboardArrowDownIcon}
        onChange={handleChange}
        value={currentLanguage}
        variant="standard"
        aria-label={Language.t('LanguageSelector.ariaLabel')}
      >
        {LANGUAGE_OPTIONS.filter((lang) =>
          availableLanguages.includes(lang.value),
        ).map((lang) => (
          <MenuItem key={lang.value} value={lang.value}>
            {lang.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </Container>
  );
};

export default LanguageSelector;
